import MapScreen from '~/components/Map/MapScreen';
import Routes from '~/routes/routes';

import MapLayout from '~/layouts/MapLayout/MapLayout';
import NotFoundScreen from '~/components/common/NotFound/NotFoundScreen';
import ProjectListScreen from '~/screens/ProjectList/ProjectListScreen';
import AppLayout from '~/layouts/AppLayout/AppLayout';
import MapLayersScreen from '~/screens/MapLayersScreen/MapLayersScreen';
import DirectoriesScreen from '~/screens/DirectoriesScreen/DirectoriesScreen';
import SettingScreen from '~/screens/SettingScreen/SettingScreen';
import ProfileScreen from '~/screens/ProfileScreen/ProfileScreen';
import UploadTaskScreen from '~/screens/UploadTaskScreen/UploadTaskScreen';
import OrganizationScreen from '~/screens/OrganizationScreen/OrganizationScreen';
import OrganizationDetailScreen from '~/screens/OrganizationDetailScreen/OrganizationDetailScreen';
import OrganizationRegistrationScreen from '~/screens/OrganizationRegistrationScreen/OrganizationRegistrationScreen';
import OrganizationUpdateScreen from '~/screens/OrganizationUpdateScreen/OrganizationUpdateScreen';
import Project3DScreen from '~/screens/Project3DScreen';
import TransferToMobileScreen from '~/screens/TransferToMobileScreen/TransferToMobileScreen';
import FreePhotoScreen from '~/screens/FreePhotoScreen/FreePhotoScreen';

import HomeScreen from '~/screens/HomeScreen/HomeScreen';
import { FormBuilderScreen } from '~/screens/FormBuilderScreen/FormBuilderScreen';
import { CollectFormScreen } from '~/screens/CollectFormScreen/CollectFormScreen';
import { CollectFormTemplateScreen } from '~/screens/CollectFormTemplateScreen/CollectFormTemplateScreen';
import LoginScreen from '~/screens/Auth_Login/LoginScreen';
import AuthLayout from '~/layouts/AuthLayout/AuthLayout';
import ActionSplashScreen from '~/screens/ActionSplashScreen/ActionSplashScreen';

const routes = [
  { path: Routes.HOME, component: HomeScreen, layout: null },
  { path: Routes.LOGIN, component: LoginScreen, layout: AuthLayout },
  { path: Routes.PROJECT_DETAIL, component: MapScreen, layout: MapLayout },
  { path: Routes.PROJECT_3D, component: Project3DScreen, layout: null },

  { path: Routes.PROJECT, component: ProjectListScreen, layout: AppLayout },
  { path: Routes.MAP_LAYERS, component: MapLayersScreen, layout: AppLayout },
  { path: Routes.DIRECTORIES, component: DirectoriesScreen, layout: AppLayout },
  { path: Routes.SETTING, component: SettingScreen, layout: AppLayout },
  { path: Routes.PROFILE, component: ProfileScreen, layout: AppLayout },
  { path: Routes.UPLOAD_TASK, component: UploadTaskScreen, layout: AppLayout },
  { path: Routes.ORGANIZATION, component: OrganizationScreen, layout: AppLayout },
  { path: Routes.ORGANIZATION_DETAIL, component: OrganizationDetailScreen, layout: AppLayout },
  { path: Routes.ORGANIZATION_REGISTRATION, component: OrganizationRegistrationScreen, layout: AppLayout },
  { path: Routes.ORGANIZATION_UPDATE, component: OrganizationUpdateScreen, layout: AppLayout },
  { path: Routes.TRANSFER_TO_MOBILE, component: TransferToMobileScreen, layout: AppLayout },
  { path: Routes.FREE_PHOTOS, component: FreePhotoScreen, layout: AppLayout },

  // Project Collect Forms
  { path: Routes.COLLECT_FORMS, component: CollectFormScreen, layout: AppLayout },

  // Collect Form Templates & Designer
  { path: Routes.COLLECT_FORM_TEMPLATES, component: CollectFormTemplateScreen, layout: AppLayout },
  { path: Routes.COLLECT_FORM_TEMPLATE_DESIGN, component: FormBuilderScreen, layout: null },
  { path: Routes.COLLECT_FORM_TEMPLATE_DESIGN_EDIT, component: FormBuilderScreen, layout: null },

  // Form Builder legacy aliases
  { path: Routes.COLLECT_FORM_DESIGN, component: FormBuilderScreen, layout: null },
  { path: Routes.COLLECT_FORM_DESIGN_EDIT, component: FormBuilderScreen, layout: null },
  { path: Routes.FORM_BUILDER, component: CollectFormTemplateScreen, layout: AppLayout },
  { path: Routes.FORM_BUILDER_EDIT, component: FormBuilderScreen, layout: null },

  // Action Gateway & Map Data redirect routes
  { path: Routes.ACTION_GATEWAY, component: ActionSplashScreen, layout: null },
  { path: Routes.MAP_DATA_REDIRECT, component: ActionSplashScreen, layout: null },

  { path: Routes.NOT_FOUND, component: NotFoundScreen },
];

export { routes };
